import type { JoinSplitNote } from "../joinsplit/types";

export interface PrivateFeeQuote {
  id: string;
  pool: string;
  chainId: number;
  controller: string;
  terms: string[];
  termsHash: string;
  amounts: {
    grossAmount: string;
    recipientAmount: string;
    protocolFee: string;
    partnerFee: string;
    gasReimbursement: string;
    totalFee: string;
  };
  feeOutputs: (Record<string, any> | null)[];
  authorization?: { quote: Record<string, any>; signature: string };
  request?: {
    token?: string;
    gasFor?: string;
    recipient?: string;
    swapRoute?: any;
    bridgeRoute?: any;
  };
  bridge?: {
    relayerAddress: string;
    transaction: { to: string; data: string; value: string; chainId: number };
  };
  swap?: {
    transaction: { to: string; data: string; value: string; chainId: number };
  };
}
export function readFeeNote(note: Record<string, any>): JoinSplitNote {
  return {
    ...note,
    npk: BigInt(note.npk),
    random: BigInt(note.random),
    value: BigInt(note.value),
    tokenHash: BigInt(note.tokenHash),
  } as JoinSplitNote;
}
